/* eslint-disable react/prefer-stateless-function */

import React from 'react';
import ReactModal from 'react-modal';

// DEPRECATED: use src/components/dialog/ConfirmationDialog.component.jsx
class ConfirmationDialog extends React.Component {
  static defaultProps = {
    children: [],
    disabled: false,
    additionalClass: '',
  };

  render() {
    const { title, leftButtonText, onLeft, rightButtonText, onRight, disabled } = this.props;
    return (
      <ReactModal
        isOpen
        closeTimeoutMS={0}
        contentLabel={title}
        ariaHideApp
        shouldCloseOnOverlayClick
        role="dialog"
        style={{
          overlay: {
            zIndex: 500,
          },
        }}
        className={{
          base: 'dialog-container',
          afterOpen: 'dialog-container',
          beforeClose: 'dialog-container',
        }}
      >
        <div data-bem="ConfirmationDialog__content--client-profile" className={`dialog  ${this.props.additionalClass ? this.props.additionalClass : ''}`}>
          <div className="dialog-header">
            <h2>{title}</h2>
          </div>
          <div className="body">{this.props.children}</div>
          <div className="dialog-footer">
            <button className="btn btn-violet-link" tabIndex={0} onClick={onLeft}>
              {leftButtonText}
            </button>
            <button className="btn btn-violet" tabIndex={0} onClick={onRight} disabled={disabled}>
              {rightButtonText}
            </button>
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default ConfirmationDialog;
